import React from 'react';
import { useTranslate } from 'react-admin';
import { SelectInput } from 'react-admin';
import { useAllMenu } from '~/hooks/menu';

export interface Props {
  source: string;
  label: string;
  className?: string;
  alwaysOn?: boolean;
  onChange?: (e: any) => void;
  validate?: () => void;
  allowEmpty?: boolean;
  helperText?: boolean;
}

const MenuSelect = ({
  source,
  label,
  className,
  alwaysOn,
  onChange,
  validate,
  allowEmpty,
  helperText = false,
}: Props) => {
  const { data: menu, isLoading } = useAllMenu();
  const translate = useTranslate();
  const t = (key: string): string => translate(`components.ra.fields.MenuSelect.${key}`);
  const emptyChoice = { id: '', name: t('any') };
  const choices =
    menu?.map((menu) => {
      return {
        id: menu.id,
        name: menu.name,
      };
    }) ?? [];
  return (
    <SelectInput
      choices={allowEmpty ? [emptyChoice, ...choices] : choices}
      className={className}
      source={source}
      label={label}
      helperText={helperText}
      allowEmpty={false}
      alwaysOn={alwaysOn}
      onChange={onChange}
      validate={validate}
      loading={isLoading}
      emptyText={t('any')}
    />
  );
};

export default MenuSelect;
